import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { I18nLabel } from '../models/common/i18n-label';

@Pipe({ name: 'i18nLabel', pure: false })
export class I18nLabelPipe implements PipeTransform, OnDestroy {

  private currentLang: string;
  private sub: Subscription;

  constructor(private translate: TranslateService) {
    this.currentLang = this.translate.currentLang || this.translate.defaultLang;
    this.sub = this.translate.onLangChange.subscribe(e => {
      this.currentLang = e.lang;
    });
  }

  transform(value: I18nLabel | null | undefined): string {
    if (!value) return '';
    return value[this.currentLang] || value.default_value || '';
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
